import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { BrandMark } from '../primitives/BrandMark';
import { MonoLabel } from '../primitives/MonoLabel';

export interface AuthChromeProps {
  pageLabel: ReactNode;
}

export function AuthChrome({ pageLabel }: AuthChromeProps) {
  return (
    <header className="pn-auth-chrome">
      <div className="pn-page pn-auth-chrome-inner">
        <Link to="/landing" className="pn-auth-brand" aria-label="Penrose home">
          <BrandMark className="pn-auth-brand-mark" />
          <span className="pn-auth-brand-word">Penrose</span>
        </Link>
        <span className="pn-auth-chrome-divider" aria-hidden="true" />
        <MonoLabel size="md" tracking="widest" className="pn-auth-chrome-label">
          {pageLabel}
        </MonoLabel>
      </div>
    </header>
  );
}
